import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  name: 'auth-store',

  state: {
    auth: {},
    storage_key: 'auth'
  },

  getters: {
    authHeaders: (state, getters) => {
      return JSON.parse(getters.getRecord)
    },

    getRecord: state => {
      return localStorage.getItem(state.storage_key)
    }
  },

  actions: {
    clearAuth (context) {
      context.commit('clearAuth')
      context.commit('setAuth')
    },

    // This should be cleaned up to better maximize state handling.
    loggedIn (context) {
      context.commit('refreshAuthState')
      const hdrs = context.state.auth

      if (hdrs['X-Auth-Key']) {
        for (let hdr in hdrs) {
          Vue.http.headers.common[hdr] = hdrs[hdr]
        }

        return hdrs
      }
    },

    getRecord (context) {
      context.commit('refreshAuthState')

      return context.state.auth
    },

    setAuth (context, payload) {
      context.commit('setAuth', payload)
      context.commit('setRecord')

      return context.dispatch('loggedIn')
    }
  },

  mutations: {
    clearAuth (state) {
      // Clear previously assigned auth headers.
      for (let hdr in state.auth) {
        delete Vue.http.headers.common[hdr]
      }

      state.auth = {}
      localStorage.setItem(state.storage_key, '{}')
    },

    refreshAuthState (state) {
      state.auth = JSON.parse(localStorage.getItem(state.storage_key) || '{}')
    },

    setAuth (state, payload) {
      state.auth = payload
    },

    setRecord (state) {
      localStorage.setItem(state.storage_key, JSON.stringify(state.auth))
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/AuthStore.js